import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../../components/common/general/CustomText/CustomText";
import type { TeamRole } from "../contexts/TeamMembersContext";

interface AvatarMember {
  id: string;
  name: string;
  role: TeamRole;
}

interface CommentAvatarProps {
  member: AvatarMember;
  size?: number;
}

const roleAvatarColors: Record<TeamRole, { bg: string; text: string }> = {
  architect: { bg: "#ECFDF3", text: "#027A48" },
  faculty: { bg: "#EDE9FE", text: "#6D28D9" },
  "instructional-designer": { bg: "#DBEAFE", text: "#1D4ED8" },
  observer: { bg: "#F3F4F6", text: "#667085" },
};

function getInitials(name: string): string {
  return name
    .replace(/^(Dr|Prof|Mr|Ms|Mrs)\.?\s+/i, "")
    .split(" ")
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

function CommentAvatar({ member, size = 32 }: CommentAvatarProps) {
  const colors = roleAvatarColors[member.role];

  return (
    <View style={[styles.avatar, { width: size, height: size, borderRadius: size / 2, backgroundColor: colors.bg }]}>
      <CustomText
        text={getInitials(member.name)}
        useTranslationText={false}
        style={[styles.avatarInitials, { fontSize: size * 0.34, color: colors.text }]}
      />
    </View>
  );
}

export default CommentAvatar;

const styles = StyleSheet.create({
  avatar: {
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  avatarInitials: {
    fontWeight: "600",
  },
});
